import {
  EducationalScreenBodyChildResultV2,
  Maybe,
  Typenames,
} from '@varo/graphql-schema-types';
import { StyleSheet, View } from 'react-native';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

import EligibilityContent from './EligibilityContent';
import IconTextComponentCell from './IconTextComponentCell';

type EligibilityScreenBodyProps = {
  body?: Array<EducationalScreenBodyChildResultV2>;
  disclaimer?: Maybe<string> | undefined;
};

const EligibilityScreenBody = ({
  body = [],
  disclaimer,
}: EligibilityScreenBodyProps) => {
  const disclaimerText: string | undefined = disclaimer ?? undefined;

  return (
    <>
      <EligibilityContent body={body} />
      {body?.map((item: EducationalScreenBodyChildResultV2) => {
        if (!item) {
          return null;
        }

        switch (item.__typename) {
          case Typenames.BulletComponent:
            return (
              <ContentList key={`bullet-${item.id}`} contentList={item.items} />
            );
          case Typenames.IconTextComponent:
            return (
              <IconTextComponentCell
                key={`iconText-${item.id}`}
                iconTextItems={item.items}
              />
            );
          default:
            return null;
        }
      })}
      {disclaimerText && (
        <View style={styles.disclaimerText}>
          <BodyXSText numberOfLines={0}>{disclaimerText}</BodyXSText>
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  disclaimerText: {
    marginHorizontal: theme.spacing.m,
    marginVertical: theme.spacing.s,
  },
});

export default EligibilityScreenBody;
